/* esm.sh - unhead@2.1.12/dist/shared/unhead.B5FWS6X0 */
export * from "/*unhead@2.1.12/esnext/dist/shared/unhead.B5FWS6X0.mjs";
